import React from 'react';
import { FadeInSection } from './FadeInSection';
import { useLanguage } from './LanguageContext';
import { translations } from './translations';
export const WorkWithCenia = () => {
  const {
    lang
  } = useLanguage();
  const t = translations[lang].work;
  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <FadeInSection className="relative w-full h-screen min-h-[700px] flex items-end justify-center overflow-hidden" data-id="element-288">
      {/* Background */}
      <div className="absolute inset-0 z-0" data-id="element-289">
        <img src="https://cdn.magicpatterns.com/uploads/mXoYSRXKCzR7JD62P5X1Bt/CeniaBadillo-0151.jpg" alt="Cenia Badillo" className="w-full h-full object-cover object-[center_20%]" data-id="element-290" />
        <div className="absolute inset-0 bg-black/55" data-id="element-291" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 pb-[40px] pt-[320px]
 flex flex-col items-center text-center" data-id="element-292">


        <h2 className="font-serif-display text-3xl md:text-7xl uppercase tracking-wider text-white mb-10" data-id="element-293">
          {t.headline}
        </h2>

        <p className="body-text text-lg md:text-xl text-white/90 max-w-2xl mb-12" data-id="element-294">
          {t.body}
        </p>

        <button onClick={scrollToContact} className="px-10 py-4 border border-white text-white uppercase tracking-widest text-sm hover:bg-[#c9a96e] hover:border-[#c9a96e] transition-colors duration-300" data-id="element-295">
          {t.cta}
        </button>
      </div>
    </FadeInSection>;
};